import { gql } from '@apollo/client';
export const transactionDetailsFragment = gql `
  fragment transactionDetailsFields on RecentTransactionDetailsPayload {
    type
    assetCode
    assetLabel
    assetIconUrl

    fee
    feeAssetCode

    amount

    fromAmount
    toAmount
    fromAsset {
      name
      code
      iconUrl
    }
    toAsset {
      name
      code
      iconUrl
    }

    quoteAmount
    quoteAssetCode
    quoteAssetLabel
    quoteAssetIconUrl

    krakenCost
    krakenFee
    totalKrakenCost
  }
`;
export const transactionDetailsExtendedFragment = gql `
  fragment transactionDetailsExtendedFields on TransactionDetailPayload {
    type
    assetCode
    assetLabel

    fee
    feeAssetCode

    amount

    quoteAmount
    quoteAssetCode
    quoteAssetLabel

    krakenCost
    krakenFee
    totalKrakenCost

    status
    subStatus
    network
    internalOperationId
    destination
    sourceAddress
    date
    rate
    blockchainTransactionId
    recipientAccountNumber

    bitnetId

    reasonForFailure
  }
`;
//TODO: should add
// reason
// initiatorEmail
//# sourceMappingURL=transaction.js.map